// Action types for Floor Plan CRUD
export const FLOOR_PLAN_LIST_REQUEST = 'FLOOR_PLAN_LIST_REQUEST';
export const FLOOR_PLAN_LIST_SUCCESS = 'FLOOR_PLAN_LIST_SUCCESS';
export const FLOOR_PLAN_LIST_FAIL = 'FLOOR_PLAN_LIST_FAIL';

export const FLOOR_PLAN_CREATE_REQUEST = 'FLOOR_PLAN_CREATE_REQUEST';
export const FLOOR_PLAN_CREATE_SUCCESS = 'FLOOR_PLAN_CREATE_SUCCESS';
export const FLOOR_PLAN_CREATE_FAIL = 'FLOOR_PLAN_CREATE_FAIL';
export const FLOOR_PLAN_CREATE_RESET = 'FLOOR_PLAN_CREATE_RESET';

export const FLOOR_PLAN_UPDATE_REQUEST = 'FLOOR_PLAN_UPDATE_REQUEST';
export const FLOOR_PLAN_UPDATE_SUCCESS = 'FLOOR_PLAN_UPDATE_SUCCESS';
export const FLOOR_PLAN_UPDATE_FAIL = 'FLOOR_PLAN_UPDATE_FAIL';
export const FLOOR_PLAN_UPDATE_RESET = 'FLOOR_PLAN_UPDATE_RESET';

export const FLOOR_PLAN_DELETE_REQUEST = 'FLOOR_PLAN_DELETE_REQUEST';
export const FLOOR_PLAN_DELETE_SUCCESS = 'FLOOR_PLAN_DELETE_SUCCESS';
export const FLOOR_PLAN_DELETE_FAIL = 'FLOOR_PLAN_DELETE_FAIL';
export const FLOOR_PLAN_DELETE_RESET = 'FLOOR_PLAN_DELETE_RESET';


